interface BrandMarkProps {
  size?: number;
  className?: string;
}

/**
 * BrandMark — el isologo de orborix speak: la o de la marca madre con sus dos
 * ondas al NE ("la o que habla"), declinada en el violeta de speak. Fuente:
 * claude-design/orborix-brand/speak/v1/. Es el ÚNICO mark de marca de la app
 * (auth, sidebar desktop, AppLoader); no dibujar orbs/anillos ad-hoc — el
 * orb/planeta quedó vetado como símbolo de marca.
 */
export function BrandMark({ size = 22, className }: BrandMarkProps) {
  return (
    <svg viewBox="392 330 228 228" width={size} height={size} className={className} aria-hidden>
      <path
        fill="var(--purple)"
        d="m 486.34875,525.91 q -10.81,0 -21.62,-4.14 -10.58,-4.37 -19.32,-12.19 -8.74,-7.82 -13.8,-18.63 -5.06,-11.04 -5.06,-24.38 0,-12.42 4.6,-23 4.6,-10.81 12.88,-19.09 8.28,-8.28 18.86,-12.88 10.81,-4.83 23,-4.83 16.56,0 29.9,8.05 13.57,7.82 21.62,21.39 8.05,13.57 8.05,30.13 0,14.03 -5.29,25.07 -5.06,10.81 -13.8,18.63 -8.51,7.82 -19.09,11.96 -10.35,3.91 -20.93,3.91 z m -0.46,-34.73 q 5.52,0 11.27,-2.76 5.75,-2.76 9.66,-8.28 3.91,-5.52 3.91,-14.03 0,-7.36 -3.22,-12.88 -3.22,-5.52 -8.97,-8.51 -5.52,-3.22 -12.88,-3.22 -6.9,0 -12.42,3.22 -5.29,3.22 -8.74,8.97 -3.22,5.52 -3.22,12.65 0,8.28 3.68,14.03 3.91,5.52 9.66,8.28 5.75,2.53 11.27,2.53 z"
      />
      <path
        className="brand-mark-wave"
        d="M 499.5 388.3 A 79.4 79.4 0 0 1 538.8 407.5"
        fill="none"
        stroke="var(--purple)"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        className="brand-mark-wave brand-mark-wave--2"
        d="M 502.6 370.7 A 97.3 97.3 0 0 1 550.8 394.2"
        fill="none"
        stroke="var(--purple)"
        strokeWidth="7"
        strokeLinecap="round"
      />
    </svg>
  );
}
